var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { applyCyAttribute } from "../../utils";
var ValidateSuccess = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 26 26", width: "100%", height: "100%" }, props, applyCyAttribute('validateSuccess')),
        React.createElement("path", { fill: color, fillRule: "evenodd", d: "M13 0c1.794 0 3.483.339 5.065 1.016a13.045 13.045 0 0 1 4.14 2.78 13.045 13.045 0 0 1 2.78 4.139C25.66 9.517 26 11.205 26 13c0 1.794-.339 3.483-1.016 5.065a13.045 13.045 0 0 1-2.78 4.14 13.045 13.045 0 0 1-4.139 2.78C16.483 25.66 14.795 26 13 26c-1.794 0-3.483-.339-5.065-1.016a13.045 13.045 0 0 1-4.14-2.78 13.045 13.045 0 0 1-2.78-4.139C.34 16.483 0 14.795 0 13c0-1.794.339-3.483 1.016-5.065a13.045 13.045 0 0 1 2.78-4.14 13.045 13.045 0 0 1 4.139-2.78C9.517.34 11.205 0 13 0zm5.18 8.252a.803.803 0 0 1 .584-.254c.22 0 .414.085.584.254a.775.775 0 0 1 .228.571.775.775 0 0 1-.228.572l-8.1 8.15-.05.05-.052.051a.737.737 0 0 1-.57.254.737.737 0 0 1-.572-.254l-4.037-4.011a.775.775 0 0 1-.229-.572c0-.228.076-.418.229-.57a.803.803 0 0 1 .584-.255c.22 0 .414.085.584.254l3.428 3.428 7.617-7.668z" })));
};
ValidateSuccess.defaultProps = {
    color: '#4E9500',
};
export default ValidateSuccess;
//# sourceMappingURL=ValidateSuccess.js.map